module.exports = __webpack_public_path__ + "static/media/law-min.69a3ba48.jpg";